import React from "react";
import { useNavigate } from "react-router-dom";
import './WarningLoginModal.css';

const WarningLoginModal = ({ isOpen, onClose, message="1개 이상의 건물을 관리하려면 로그인이 필요해요" }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleLoginRedirect = () => {
        onClose();
        navigate('/login');
    };

    return (
        <div className="warning-modal-overlay">
            <div className="warning-login-modal">
                <div className="warning-login-modal-title">
                    {message}
                </div>
                <div className="warning-login-modal-content">
                    로그인하고 더 많은 기능을 편하게 사용해 보세요
                </div>
                <div className="warning-modal-buttons">
                    <button className="warning-login-close-button" onClick={onClose}>취소</button>
                    <button className="warning-login-button" onClick={handleLoginRedirect}>로그인 하러가기</button>
                </div>
            </div>
        </div>
    );
};

export default WarningLoginModal;
